<div class="add-container">
    <h1 class="add-title text-center">
        Actualizare Semnatari
        <span *ngIf="manual_override == false">Template Document</span>
        <span *ngIf="manual_override == true">Document Generat</span>
        <br /> <span>{{data.name}}</span>
    </h1>
    <button class="btn btn-light close-button" type="button" (click)="closeDialog()">
        {{ helper.dialogConfig.buttonLabels.close }}
    </button>

    <div *ngIf="data.document_generabil_dual == true">
        <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onSwitchChange($event)"
            [value]="destinationToggle">
            <mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
            <mat-button-toggle value="toCetatean">Exemplar Cetățean</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <mat-expansion-panel class="add-card__form">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <!-- <mat-spinner diameter="32" class="mr-3" *ngIf="isLoading"></mat-spinner> -->
                <span class="w-100">Vă rugăm să selectați semnatarii doriți(funcții)</span>
                <button class="btn btn-primary" type="button" [disabled]="form.dirty"
                    (click)="updateSignaturesTemplateDocument($event)">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="add-field">
            <div *ngFor="let row of functiiOperator" class="checkbox">
                <mat-checkbox color="primary" [(ngModel)]="row.checked">
                    {{row.name}}
                </mat-checkbox>
            </div>
        </div>
    </mat-expansion-panel>

    <mat-expansion-panel class="add-card__form">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <!-- <mat-spinner diameter="32" class="mr-3" *ngIf="isLoading"></mat-spinner> -->
                <span class="w-100">Vă rugăm să ordonați semnăturile de aplicat in cadrul unui document (drag &
                    drop)</span>
                <button class="btn btn-primary" type="button" [disabled]="form.dirty" (click)="saveOrder($event)">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="add-field">
            <div class="container-fluid" cdkDropList (cdkDropListDropped)="drop($event)">
                <div class="row align-items-center draggable-item" [ngClass]="{'dragging': isDragging}"
                    *ngFor="let row of functiiSelectedOrder; let i = index" cdkDrag (cdkDragStarted)="isDragging = true"
                    (cdkDragEnded)="isDragging = false;">
                    <div class="col-md-3 ">
                        {{row.functie}}
                    </div>
                    <div class="col-md-3 d-flex align-items-center justify-content-center">
                        <span class="order">{{row.order}}</span>
                        <mat-form-field class="signature w-auto" appearance="outline">
                            <mat-label>Tip semnătură</mat-label>
                            <mat-select [(ngModel)]="row.sign_type">
                                <mat-option *ngFor="let type of signatureTypes" [value]="type.value">
                                    {{ type.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <!-- Directie Dropdown with Typeahead -->
                            <div class="col-sm-12">
                                <mat-form-field class="form-field directie-field w-100" appearance="outline">
                                    <mat-label>Direcția *</mat-label>
                                    <mat-select [(ngModel)]="row.directie_id"
                                        (selectionChange)="onDirectieChange(row, i)"
                                        (openedChange)="onDirectieDropdownOpened(i)"
                                        (closed)="onDropdownClosed(i, 'directie')"
                                        required>

                                        <!-- Sticky Search Input -->
                                        <mat-form-field class="px-2 w-100 sticky-search-input" appearance="outline"
                                            *ngIf="directiiSearchControls[i]">
                                            <mat-label>Caută direcție...</mat-label>
                                            <input matInput
                                                [formControl]="directiiSearchControls[i]"
                                                (keydown)="$event.stopPropagation()"
                                                (click)="$event.stopPropagation()"
                                                autocomplete="off">
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredDirectiiByIndex[i]?.length === 0" disabled>
                                            <span class="text-muted">Nu s-au găsit rezultate</span>
                                        </mat-option>

                                        <mat-option *ngFor="let directie of filteredDirectiiByIndex[i]"
                                            [value]="directie.id_directie">
                                            {{ directie.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- Compartiment Dropdown with Typeahead -->
                            <div class="col-sm-12">
                                <mat-form-field class="form-field compartiment-field w-100" appearance="outline">
                                    <mat-label>Compartimentul *</mat-label>
                                    <mat-select [(ngModel)]="row.compartiment_id"
                                        [disabled]="!row.directie_id"
                                        (selectionChange)="onCompartimentChange(row, i)"
                                        (openedChange)="onCompartimentDropdownOpened(i)"
                                        (closed)="onDropdownClosed(i, 'compartiment')"
                                        required>

                                        <!-- Sticky Search Input -->
                                        <mat-form-field class="px-2 w-100 sticky-search-input" appearance="outline"
                                            *ngIf="compartimenteSearchControls[i]">
                                            <mat-label>Caută compartiment...</mat-label>
                                            <input matInput
                                                [formControl]="compartimenteSearchControls[i]"
                                                (keydown)="$event.stopPropagation()"
                                                (click)="$event.stopPropagation()"
                                                autocomplete="off">
                                        </mat-form-field>

                                        <mat-option *ngIf="filteredCompartimenteByIndex[i]?.length === 0" disabled>
                                            <span class="text-muted">Nu s-au găsit rezultate</span>
                                        </mat-option>

                                        <mat-option *ngFor="let compartiment of filteredCompartimenteByIndex[i]"
                                            [value]="compartiment.id_compartiment">
                                            {{ compartiment.name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-hint *ngIf="!row.directie_id">Selectați mai întâi o direcție</mat-hint>
                                </mat-form-field>
                            </div>

                            <!-- User Dropdown with Typeahead -->
                            <div class="col-sm-12">
                                <mat-form-field class="form-field user-field w-100" appearance="outline">
                                    <mat-label>Utilizatorul implicit (opțional)</mat-label>
                                    <mat-select [(ngModel)]="row.user_id"
                                        [disabled]="!row.directie_id"
                                        (selectionChange)="onUserChange(row, i)"
                                        (openedChange)="onUserDropdownOpened(i)"
                                        (closed)="onDropdownClosed(i, 'user')">

                                        <!-- Sticky Search Input -->
                                        <mat-form-field class="px-2 w-100 sticky-search-input" appearance="outline"
                                            *ngIf="usersSearchControls[i]">
                                            <mat-label>Caută utilizator...</mat-label>
                                            <input matInput
                                                [formControl]="usersSearchControls[i]"
                                                (keydown)="$event.stopPropagation()"
                                                (click)="$event.stopPropagation()"
                                                autocomplete="off">
                                        </mat-form-field>

                                        <mat-option [value]="null">-- Fără utilizator implicit --</mat-option>

                                        <mat-option *ngIf="filteredUsersByIndex[i]?.length === 0" disabled>
                                            <span class="text-muted">Nu s-au găsit rezultate</span>
                                        </mat-option>

                                        <mat-option *ngFor="let user of filteredUsersByIndex[i]"
                                            [value]="user.id_user">
                                            {{ user.name || user.full_name }}
                                        </mat-option>
                                    </mat-select>
                                    <mat-hint *ngIf="!row.directie_id">Selectați mai întâi o direcție</mat-hint>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </mat-expansion-panel>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>
<div *ngIf="data.isCerereDetalii" class="add-action-btns"
    style="margin: 20px; display: flex; justify-content: space-between;">
    <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
        {{ helper.dialogConfig.buttonLabels.close }}
    </button>
    <button class="buttons" type="submit" mat-flat-button color="primary" (click)="save()">
        {{ helper.dialogConfig.buttonLabels.save }}
    </button>
</div>